import React, { useState, useEffect, useContext, useCallback } from 'react';
import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CNavLink,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import {
  cilLockLocked,
  cilUser,
  cilList,
  cilCreditCard,
} from '@coreui/icons';
import avatar8 from '../../assets/images/mie_sprite.png';
import { FirebaseContext } from '../../views/firebase';
import { AuthUserContext } from '../../views/session';
import { ActiveLinkContext } from '../ActiveLinkContext';
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth'; // Import from Firebase v9 modular SDK

const AppHeaderDropdown = ({ authUserC }) => {
  // Move all hooks to the top and ensure they're always called
  const [userICO, setUserICO] = useState(avatar8);
  const [userEmail, setUserEmail] = useState("");
  const [userDN, setUserDN] = useState("User");
  const firebase = useContext(FirebaseContext);
  const navigate = useNavigate();
  const { authUser } = useContext(AuthUserContext);
  const { link, setActiveLink } = useContext(ActiveLinkContext);
  const auth = getAuth();

  const handleSignOut = async () => {
    try {
      localStorage.clear();
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Sign-out error:', error);
    }
  };

  const handleNavClick = (linkType) => {
    console.log('Clicked:', linkType);
    setActiveLink(linkType);
    navigate('/dashboard');
  };

  const fetchUserIcon = useCallback(() => {
    if (!authUser) return;

    try {
      const uid = authUser.uid || "UnknownUID";
      const displayName = authUser.displayName || authUser.username || authUser.mieDisplayName || "UnknownUser";
      const email = authUser.email || "UnknownEmail";
      const photoURL = authUser.photoURL || avatar8;

      setUserICO(photoURL || avatar8);
      setUserDN(displayName);
      setUserEmail(email);
    } catch (err) {
      console.error('Error fetching user icon:', err);
      setUserICO(avatar8);
      setUserDN("User");
      setUserEmail("");
    }
  }, [authUser]);

  useEffect(() => {
    fetchUserIcon();
  }, [fetchUserIcon]);

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
        <CAvatar src={userICO} size="md" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownHeader className="bg-light fw-semibold py-2">Welcome</CDropdownHeader>
        <CDropdownItem onClick={() => handleNavClick('profile')}>
          <CIcon icon={cilUser} className="me-2" />
          {userDN}
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem
          onClick={() => {
            navigate('/orders');
          }}
          style={{ cursor: 'pointer' }}
        >
          <CIcon icon={cilList} className="me-2" />
          Orders
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem
          onClick={() => navigate('/adminpage')}
          style={{ cursor: 'pointer' }}
        >
          <CIcon icon={cilCreditCard} className="me-2" />
          Manage Subscription
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem onClick={handleSignOut}>
          <CIcon icon={cilLockLocked} className="me-2" />
          Logout
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default AppHeaderDropdown;
